import React from 'react';
import { LayoutDefault } from './LayoutDefault';
import { LayoutProfile } from './LayoutProfile';
import { LayoutScore } from './LayoutScore';

export const Layout: React.FC<{
    variant: 'layout_default' | 'layout_myscore' | 'layout_profile';
}> = ({ variant, children }) => {
    switch (variant) {
        case 'layout_myscore':
            return <LayoutScore>{children}</LayoutScore>;

        case 'layout_profile':
            return <LayoutProfile>{children}</LayoutProfile>;

        default:
        case 'layout_default':
            return <LayoutDefault>{children}</LayoutDefault>;
    }
};
